module.exports = __webpack_public_path__ + "static/img/zs26839.3380b7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/ddzs/zs26839.png
// module id = xNyZ
// module chunks = 0